import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyFormatterService } from '../../services/currency-formatter.service';
import { FeeChargeRow } from '../../models/fee-config';

@Pipe({ name: 'feeValueDisplay', pure: true })
export class FeeValueDisplayPipe implements PipeTransform {
  constructor(private currencyFormatter: CurrencyFormatterService) {}

  transform(row: FeeChargeRow): string {
    if (!row?.chargeType) return '';
    if (row.chargeType === 'FLAT') {
      const formatted = this.currencyFormatter.formatCurrency(row.value);
      if (formatted === '-') {
        const num = this.currencyFormatter.parseCurrency(row.value);
        return num === 0 ? `${this.currencyFormatter.getCurrencySymbol()}0` : '';
      }
      return formatted;
    }
    return row.value ? `${row.value}%` : '';
  }
}
